import React from 'react'
import styled from 'styled-components'

const FlexWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`
const BottomButtons = ({ children }) => (
    <FlexWrapper>
        {children}
    </FlexWrapper>
)

export default BottomButtons


// WEBPACK FOOTER //
// ./src/Shared/BottomButtons.js